export default {
  zh: {
    explain: '成为联盟推广会员后，好友通过您的推广链接或者是邀请码进入 Plex加速器注册帐号，该帐号充值成功，您将获得 ￥2.8 现金奖励。',
    rewardRules: '结算方式及标准',
    rulesList: [
      '分成结算方式：好友充值成功，您将获得 ￥2.8 现金奖励',
      '结算周期：采用月结算（自然月）的方式，当您帐户中的推广收入超过 100 元人民币（含 100 元），Plex加速器将通过 PayPal 方式将推广收入支付给您。结算日期为每月的 15 日，逢节假日将顺延。',
      '如果您当期帐户中的推广收入金额不足 100 元人民币，则自动累积到次月，直至达到最低结算限额才付款。',
      '每个月的推广收入无封顶上限。'
    ],
    promotionPlatform: '推广平台：',
    promotionMethod: '推广方式：',
    companyName: '公司名称：',
    officialSite: '官网地址：',
    explanation: '说明备注：',
    becomeAffiliate: '成为联盟推广成员',
    submitMeans: '提交代表您已查看并同意',
    affiliatePolicy: '联盟推广条款',
    sure: '确定',
    pleaseAgreePolicy: '请阅读并勾选联盟推广协议',
    notice: {
      pending: '您提交的申请我们正在审核中，请您耐心等候，如有任何疑问请联系我们：',
      cancelled: '您提交的申请未通过审核。如有任何疑问请联系我们：',
      complete: '您已是联盟推广成员，无需再次申请。如有任何疑问请联系我们：',
      notLogin: '您还未登录，请登录后提交申请'
    }
  },
  en: {
    explain: 'Once you become a PlexVPN affiliate, send your unique affiliate code or affiliate link to your friends, and invite them to use PlexVPN. For every successful purchase of a plan by your friend, you will receive $0.45 as commission.',
    rewardRules: 'Reward Rules and Standard',
    rulesList: [
      'Commission rate: For every successful purchase of a plan by your friend, you will receive $0.45 as commission.',
      'Payment period: We pay our affiliate commissions through PayPal. When you withdraw the commission, add your PayPal details to your affiliate account. We pay affiliate commissions on the 15th of every month for the previous month’s commissions.',
      'If your commission for a given month total below $50, they will rollover to the next month, until they reach $50.',
      'There are no limits to commission, the more people you invite, the more rewards you’ll get.'
    ],
    promotionPlatform: 'Promotion Platform: ',
    promotionMethod: 'Promotion Method: ',
    companyName: 'Company Name: ',
    officialSite: 'Official Site: ',
    explanation: 'Remarks/Explanation : ',
    becomeAffiliate: 'Become an Affiliate',
    submitMeans: 'By submitting this form you agree to our ',
    affiliatePolicy: 'Affiliate Policy',
    sure: 'Sure',
    pleaseAgreePolicy: 'Please read and check Affiliate Policy',
    notice: {
      pending: 'You application is under review, please be patient. If you have any questions, please feel free to contact us ',
      cancelled: 'You application is unapproved. If you have any questions, please feel free to contact us ',
      complete: 'You have already joined our affiliate program and don\'t need to apply again. If you have any questions, please feel free to contact us:',
      notLogin: 'You are not signed in, please submit your application after sign in'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/becomeAnAffiliate/lang.js